import { render, staticRenderFns } from "./ButtonDocuments.vue?vue&type=template&id=aeab133c&"
import script from "./ButtonDocuments.vue?vue&type=script&lang=js&"
export * from "./ButtonDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports